import { biLoggerFactory } from 'wix-private';

const biLogger = biLoggerFactory('logo-builder', 88, { msid: 'a49e67eb-33bf-4a76-a718-7b43f72156ed' });

$w.onReady(function () {
	//TODO: write your page related code here...

});

export async function columnStrip5_viewportEnter(event) {
	const biEventObject = {
		evid: 31,
		userEntry: ''
	};
	await biLogger.log(biEventObject);

}

export async function box1_click(event) {
	console.log(event)
	const biEventObject = {
		evid: 32,
		userEntry: ''
	};
	await biLogger.log(biEventObject);
}

export async function gallery1_itemClicked(event) {
	const biEventObject = {
		evid: 32,
		userEntry: ''
	};
	await biLogger.log(biEventObject);
}